import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { verifyPermission } from "helpers/permission";
import { useConfigRapportData } from "hooks/configs/auto-report/form/useConfigRapportData";
import { useFormState } from "hooks/configs/auto-report/form/useFormState";
import { useFormSubmit } from "hooks/configs/auto-report/form/useFormSubmit";
import { FormActions } from "components/configs/auto-report/form/FormActions";
import { FormSelect } from "components/configs/auto-report/form/FormSelect";
import { InstitutionSelect } from "components/configs/auto-report/form/InstitutionSelect";
import { useEffect } from "react";

const ConfigRapportAutoForm = (props) => {
  const { t, ready } = useTranslation();
  const { id } = useParams();

  const { data, isLoading, error, endpoint } = useConfigRapportData(
    props.plan,
    props.userPermissions,
    id
  );

  const {
    formData,
    errors,
    setErrors,
    isSubmitting,
    setIsSubmitting,
    selectedOptions,
    updateFormData,
    updateSelectedOption,
    resetForm,
  } = useFormState(data.existingConfig);


  const { handleSubmit } = useFormSubmit(
    endpoint,
    id,
    resetForm,
    setErrors,
    setIsSubmitting
  );

  const onChangePeriod = (selected) => {
    updateFormData("period", selected?.value || "");
    updateSelectedOption("period", selected);
  };

  const onChangeStaff = (selected) => {
    const staffIds = selected ? selected.map((item) => item.value) : [];
    updateFormData("staffs", staffIds);
    updateSelectedOption("staff", selected || []);
  };

  const onChangeInstitution = (selected) => {
    updateFormData("institution_id", selected?.value || "");
    updateSelectedOption("institution", selected);
  };

  const onChangeType = (selected) => {
    updateFormData("reporting_type", selected?.value || "");
    updateSelectedOption("type", selected);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(formData);
  };

  if (!ready) return null;

  if (
    !verifyPermission(
      props.userPermissions,
      "list-config-reporting-claim-my-institution"
    )
  ) {
    return null;
  }

  
  if (error) {
    return <div>Error loading data</div>;
  }

  return (
    <div
      className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <div className="kt-subheader kt-grid__item" id="kt_subheader">
        <div className="kt-container kt-container--fluid">
          <div className="kt-subheader__main">
            <h3 className="kt-subheader__title">{t("Paramètres")}</h3>
            <span className="kt-subheader__separator kt-hidden" />
            <div className="kt-subheader__breadcrumbs">
              <a href="#icone" className="kt-subheader__breadcrumbs-home">
                <i className="flaticon2-shelter" />
              </a>
              <span className="kt-subheader__breadcrumbs-separator" />
              <Link
                to="/settings/rapport-auto"
                className="kt-subheader__breadcrumbs-link"
              >
                {t("Rapport Automatique")}
              </Link>
              <span className="kt-subheader__breadcrumbs-separator" />
              <a
                href="#button"
                onClick={(e) => e.preventDefault()}
                className="kt-subheader__breadcrumbs-link"
              >
                {id ? t("Modification") : t("Ajout")}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
        <div className="row">
          <div className="col">
            <div className="kt-portlet">
              <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                  <h3 className="kt-portlet__head-title">
                    {id
                      ? t("Modification des rapports automatiques")
                      : t("Ajout des rapports automatiques")}
                  </h3>
                </div>
              </div>

              <form method="POST" className="kt-form">
                <div className="kt-portlet__body">
                  <div className="tab-content">
                    <div
                      className="tab-pane active"
                      id="kt_user_edit_tab_1"
                      role="tabpanel"
                    >
                      <div className="kt-form kt-form--label-right">
                        <div className="kt-form__body">
                          <div className="kt-section kt-section--first">
                            <div className="kt-section__body">
                              {props.plan !== "PRO" && verifyPermission(
                                props.userPermissions,
                                "config-reporting-claim-any-institution"
                              ) && (
                                <InstitutionSelect
                                  institutions={data.institutions}
                                  selectedInstitution={
                                    selectedOptions.institution
                                  }
                                  onInstitutionChange={onChangeInstitution}
                                  isLoading={isLoading}
                                  t={t}
                                />
                              )}

                              <FormSelect
                                label="Période(s)"
                                value={selectedOptions.period}
                                onChange={onChangePeriod}
                                options={data.periodData}
                                placeholder="Sélectionnez une période"
                                isLoading={isLoading}
                                required
                                errors={errors.period}
                                t={t}
                              />

                              <FormSelect
                                label="Agent(s)"
                                value={selectedOptions.staff}
                                onChange={onChangeStaff}
                                options={data.staffs.filter((staff) =>
                                  formData.institution_id
                                    ? staff.institution_id ===
                                      formData.institution_id
                                    : true
                                )}
                                placeholder="Veuillez sélectionner les agents"
                                isLoading={isLoading}
                                isMulti
                                isClearable
                                required
                                errors={errors.staffs}
                                t={t}
                              />

                              <FormSelect
                                label="Rapport"
                                value={selectedOptions.type}
                                onChange={onChangeType}
                                options={data.types}
                                placeholder="Veuillez sélectionner le rapport"
                                isLoading={isLoading}
                                isClearable
                                required
                                errors={errors.reporting_type}
                                t={t}
                              />
                            </div>

                            <FormActions
                              isSubmitting={isSubmitting}
                              onSubmit={onSubmit}
                              t={t}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userPermissions: state.user.user.permissions,
  plan: state.plan.plan,
});

export default connect(mapStateToProps)(ConfigRapportAutoForm);
